import React, { useEffect } from "react";
import { useState } from "react";

export default function CurrencyExchange() {
  const [inputValue, setInputValue] = useState("");
  const [outputValue, setOutputValue] = useState("");
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (inputValue === "") {
      console.log("input value", inputValue);
      console.log("khali dollar return");
      return;
    } else {
      console.log(inputValue, outputValue);

      const apiUrl = `https://api.freecurrencyapi.com/v1/latest?apikey=VNU5p3NuxIscp1NabZRFV7ICw5E3qfc8HjwJp6GG&currencies=${
        !isActive ? "USD" : "INR"
      }`;
      // const url = `${apiUrl}&base=USD`;
      const url = `${apiUrl}&base_currency=${isActive ? "USD" : "INR"}`;
      // console.log(url2)
      // const url = `https://api.freecurrencyapi.com/v1/latest?apikey=VNU5p3NuxIscp1NabZRFV7ICw5E3qfc8HjwJp6GG&currencies=USD&base_currency=INR`
      console.log("url chla", url);

      fetch(url)
        .then((response) => {
          return response.json();
        })

        .then((data) => {
          console.log(data.data);

          setOutputValue(() => {
            console.log("abcdf");
            if (isActive) {
              return inputValue * data.data.INR;
            } else {
              return inputValue * data.data.USD;
            }
          });

          console.log(outputValue, "output vlue");
        })
        .catch((error) => console.log(error));
    }
  }, [inputValue]);

  return (
    <>
      <h2>Currency Exchange</h2>
      <div className="currency-exchange">
        <div className="input-sign-holder">
          <span className="currency-sign">{isActive ? "$" : "₹"}</span>
          <input className="padding-input exchange-input"
            type="number"
            onBlur={(e) => setInputValue(e.target.value)}
          ></input>
        </div>

        <button className="exchange-btn"
          onClick={() => {
            setIsActive(!isActive);
            setInputValue("");
            setOutputValue("");
          }}
        > ⇅ </button>

        <div className="input-sign-holder">
          <span className="currency-sign">{!isActive ? "$" : "₹"}</span>

          <input className="padding-input exchange-input readOnly"
            type="number"
            readOnly
            value={inputValue === "" ? "" : outputValue}
          ></input>
        </div>
      </div>
    </>
  );
}
